<template>
  <a-card :bordered="false">
    <!-- 表格筛选 start -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSubmit">
        <a-row :gutter="48">
          <!-- 输入关键词查找 -->
          <!-- <a-col :md="4" :sm="24">
            <a-form-item label="账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input placeholder="请输入账号查询" v-model="queryParam.account"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="24">
            <a-form-item label="英文名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input placeholder="请输入英文名查询" v-model="queryParam.english_name"></a-input>
            </a-form-item>
          </a-col> -->
          <a-col :md="8" :sm="24">
            <a-form-item label="账单周期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-range-picker @change="onDateChange" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
          </template>
          <!-- 展开或者收起筛选项 start -->
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" htmlType="submit">查询</a-button>
              <a-button style="margin-left: 8px" @click="reset">重置</a-button>
              <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
          <!-- 展开或者收起筛选项 end -->
        </a-row>
      </a-form>
    </div>
    <!-- 表格筛选 end -->
    <!-- 表格内容操作 start -->
    <div class="table-operator" style="height:40px;">
      <!-- <a-button type="primary" style="margin-right:15px;">全部导出</a-button> -->
      <!-- <a-button type="dashed" @click="toggleTableAlert()">{{ optionAlertShow && '关闭' || '开启' }}多选</a-button> -->
      <!-- <a-dropdown v-if="optionAlertShow && selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item v-if="hasPerm('sendBillBatch')" key="1"><a-icon type="account-book" />批量发送</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown> -->
      <a-radio-group style="float:right" v-model="queryParam.status" @change="handleSubmit">
        <a-radio-button v-for="status in dict.statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
      </a-radio-group>
    </div>
    <!-- 表格内容操作 end -->
    <!-- 表格 start -->
    <tcg-table
      ref="table"
      size="default"
      rowKey="bill_id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      bordered
    >
      <span slot="time" slot-scope="text, record">
        {{ record.start_time }} ~ {{ record.end_time }}
      </span>
      <span slot="status" slot-scope="text">
        {{ text | valInDict(dict.statusDict) }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="openViewModal(record.bill_id)">查看</a>
        <a-divider v-if="record.status === 'SEND'" type="vertical" />
        <a-popconfirm
          v-if="record.status === 'SEND'"
          title="确认签收账单吗"
          @confirm="handleDone(record.bill_id)"
          okText="确认"
          cancelText="取消"
        >
          <a href="#">签收</a>
        </a-popconfirm>
      </span>
    </tcg-table>
    <!-- 表格 end -->
    <!-- 查看弹出 -->
    <billDrawer v-if="viewVisible" :visible="viewVisible" :id="id" @hide="cancelViewDrawer" @finish="finishViewAndEdit"/>
  </a-card>
</template>
<script>
import { getPre, getList, doneBill } from '@/api/bill'
import { TcgTable } from '@/components'
import billDrawer from './billDrawer'
import _ from 'lodash'

export default {
  components: {
    TcgTable,
    billDrawer
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18,
        offset: 1
      },
      // 时间
      time: [],
      // 查看抽屉状态开关
      viewVisible: false,
      // id
      id: '',
      // 字典
      dict: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        status: '',
        startTime: '',
        endTime: ''
      },
      // 表头
      columns: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '账单周期',
          dataIndex: 'start_time',
          scopedSlots: { customRender: 'time' }
        },
        {
          title: '正式课数',
          dataIndex: 'formal_class_count'
        },
        {
          title: '体验课数',
          dataIndex: 'trial_class_count'
        },
        {
          title: '订单数',
          dataIndex: 'order_count'
        },
        {
          title: '复购量',
          dataIndex: 'order_paynum_count'
        },
        {
          title: '老师得分',
          dataIndex: 'teacher_point_count'
        },
        {
          title: '得分率',
          dataIndex: 'point_rate'
        },
        {
          title: '复购率',
          dataIndex: 'repurchase_rate'
        },
        {
          title: '订单奖金',
          dataIndex: 'order_money'
        },
        {
          title: '课程工资',
          dataIndex: 'course_money'
        },
        {
          title: '延时扣款',
          dataIndex: 'deduct_money'
        },
        {
          title: '其他奖励',
          dataIndex: 'reaward_money'
        },
        {
          title: '工资合计',
          dataIndex: 'total_money'
        },
        {
          title: '生成时间',
          dataIndex: 'create_time',
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '操作',
          dataIndex: 'uid',
          key: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res
          })
      },
      selectedRowKeys: [],
      selectedRows: [],
      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          Time: this.onSelectChange
        }
      },
      optionAlertShow: true,
      confirmLoading: false
    }
  },
  created () {
    this.toggleTableAlert()
    this.handelPre()
  },
  methods: {
    handelPre () {
      getPre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.dict = _.get(res, 'values', {})
        }
      })
    },
    onDateChange(date, dateString) {
      this.queryParam.startTime = dateString[0]
      this.queryParam.endTime = dateString[1]
    },
    // 重置按钮
    reset () {
      this.queryParam = {
        status: '',
        startTime: '',
        endTime: ''
      }
    },
    // 关闭查看按钮事件
    cancelViewDrawer () {
      this.viewVisible = false
    },
    // 打开查看抽屉
    openViewModal (id) {
      this.id = id
      this.viewVisible = true
    },
    // 在查看抽屉中完成编辑
    finishViewAndEdit () {
      this.$refs.table.refresh(true)
    },
    // 提交筛选
    handleSubmit (e) {
      e.preventDefault()
      this.$refs.table.refresh(true)
    },
    // 切换提示
    toggleTableAlert () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    // 表格选择
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 批量操作按钮事件
    handleMenuClick (e) {
     let billIds = '' 
      billIds = this.selectedRowKeys.join(',')
      if (billIds === '') {
        this.$message.warning('请选择数据')
      }
      const data = {
        bill_ids: billIds
      }
      if (e.key === '1') {
        sendBillBatch(data).then(res => {
          if (_.get(res, 'code') === 200) {
            this.$message.success('操作成功')
            this.$refs.table.refresh(true)
          }
        })
      }
    },
    handleDone (billId) {
      doneBill({ bill_id: billId }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('操作成功')
          this.$refs.table.refresh(true)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
